import React, { useEffect } from 'react';
import Config from 'arbitrip-common/client/utils/Config';

const DocumentTitle = ({ title, children }) => {
	let staticTitle = null;

	if (Config.is_letstay) {
		staticTitle = 'Let’Stay';
	} else if (Config.htz) {
		staticTitle = 'TripZone';
	}

	if (staticTitle) {
		document.title = staticTitle;
		return React.Children.only(children);
	}

	useEffect(() => {
		document.title = title;
	}, [title]);

	return React.Children.only(children);
};

export default DocumentTitle;
